import { useState, useEffect, useRef } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'
import { ESPACIOS, entraAOt, homeDe, puedeEntrar } from './espacios'
import { navComercial } from './comercial/comercialLogica'
import { RedimensionarTablas } from './AnchoColumnas'
import { setEspacioInicio, getTimeOffInbox } from '../api/client'
import NotificationBell from './NotificationBell'
import AlertModal from './AlertModal'
import LanguageToggle from './LanguageToggle'

// ── SVG Icons ────────────────────────────────────────────────────────────────
const Icons = {
  Dashboard: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  PlanWeek: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  Schedule: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  ThisWeek: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="8" height="8" rx="1"/><rect x="13" y="3" width="8" height="5" rx="1"/>
      <rect x="13" y="10" width="8" height="11" rx="1"/><rect x="3" y="13" width="8" height="8" rx="1"/>
    </svg>
  ),
  Team: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  Projects: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  TimeOff: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4"/>
      <line x1="12" y1="2" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22"/>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
      <line x1="2" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="22" y2="12"/>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </svg>
  ),
  Status: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  Plus: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  SCurve: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 20 C6 20 6 12 12 12 C18 12 18 4 21 4"/><polyline points="17 4 21 4 21 8"/>
    </svg>
  ),
  Users: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="7" r="4"/>
      <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M21 21v-2a4 4 0 0 0-3-3.87"/>
    </svg>
  ),
  Key: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 2l-9.6 9.6"/><path d="M15.5 7.5l3 3L22 7l-3-3"/><circle cx="7.5" cy="15.5" r="5.5"/>
    </svg>
  ),
  Building: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/>
      <path d="M8 6h.01"/><path d="M12 6h.01"/><path d="M16 6h.01"/><path d="M8 10h.01"/><path d="M12 10h.01"/><path d="M16 10h.01"/><path d="M8 14h.01"/><path d="M12 14h.01"/><path d="M16 14h.01"/>
    </svg>
  ),
  Tag: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
  ),
  Settings: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  Cart: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/>
    </svg>
  ),
  CRM: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
    </svg>
  ),
  Briefcase: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><path d="M2 13h20"/>
    </svg>
  ),
  Logout: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  ChevronLeft: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
  Tasks: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
      <polyline points="3 6 4 7 6 5"/><polyline points="3 12 4 13 6 11"/><polyline points="3 18 4 19 6 17"/>
    </svg>
  ),
  Operations: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21V11l5 3v-3l5 3v-3l5 3V4h3v17z"/>
      <path d="M7 17h1M11 17h1M15 17h1"/>
      <path d="M2 21h20"/>
    </svg>
  ),
  Board: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="6" height="6" rx="1"/>
      <rect x="3" y="14" width="6" height="6" rx="1"/>
      <rect x="11" y="4" width="10" height="6" rx="1"/>
      <rect x="11" y="14" width="10" height="6" rx="1"/>
    </svg>
  ),
  Warehouse: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5 12 4l9 5.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>
      <rect x="7" y="13" width="4" height="4"/>
      <rect x="13" y="13" width="4" height="4"/>
    </svg>
  ),
  Requests: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="3" width="12" height="18" rx="2"/>
      <path d="M9 7h6"/><path d="M9 11h6"/><polyline points="9 16 11 18 15 14"/>
    </svg>
  ),
  Wrench: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
    </svg>
  ),
  Help: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <path d="M9.1 9a3 3 0 1 1 5.2 2c-.9.7-2.3 1.2-2.3 2.5"/>
      <line x1="12" y1="17" x2="12" y2="17.01"/>
    </svg>
  ),
}

function initials(name) {
  return (name || '?').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
}

// ── Workspace modes ──────────────────────────────────────────────────────────
const MODES = [
  {
    id: 'engineering',
    ...ESPACIOS.engineering,
    Icon: Icons.Dashboard,
  },
  {
    id: 'operations',
    ...ESPACIOS.operations,
    Icon: Icons.Operations,
  },
  {
    id: 'acquisitions',
    ...ESPACIOS.acquisitions,
    Icon: Icons.Cart,
  },
  {
    id: 'crm',
    ...ESPACIOS.crm,
    Icon: Icons.CRM,
  },
  {
    // The new Comercial module (its CRM: organizations, contacts), by function.
    id: 'comercial',
    ...ESPACIOS.comercial,
    Icon: Icons.Briefcase,
  },
  {
    id: 'c_level',
    ...ESPACIOS.c_level,
    Icon: Icons.SCurve,
  },
  {
    // The company's people, their areas and accounts (routers/admin_people.py).
    // RRHH and c_level get in for Contratos only (their home there).
    id: 'admin',
    home: '/admin/personas',
    Icon: Icons.Users,
    roles: ['admin', 'rrhh', 'c_level'],
  },
]

// `/management` is the one route with two legitimate homes: admins reach it
// from engineering, c-level users from their own sidebar. Resolving it by role
// keeps a c_level-only user out of engineering chrome they have no access to.
// Routes every workspace links to (Settings, API keys, the company directory,
// the purchase request in each sidebar, a purchase's detail): they belong to
// no mode, so they keep the one the user was in instead of throwing them back
// to engineering.
const SHARED_PATHS = ['/settings', '/api-keys', '/requests/purchases', '/personas']
const MODE_KEY = 'workspace_mode'

// null = a shared route (see SHARED_PATHS).
function modeFromPath(path, roles = []) {
  if (SHARED_PATHS.some(p => path === p || path.startsWith(`${p}/`))) return null
  if (path.startsWith('/purchases/') && path !== '/purchases/dashboard') return null
  if (path.startsWith('/operations')) return 'operations'
  if (path.startsWith('/purchases')) return 'acquisitions'
  if (path.startsWith('/compras')) return 'acquisitions'
  if (path.startsWith('/crm')) return 'crm'
  if (path.startsWith('/comercial')) return 'comercial'
  if (path.startsWith('/c-level')) return 'c_level'
  if (path.startsWith('/admin')) return 'admin'
  // Capacity is an executive surface, so it wears the executive chrome even
  // for an admin, who would otherwise land in the engineering sidebar.
  if (path.startsWith('/capacity')) return 'c_level'
  if (path.startsWith('/scenarios')) return 'c_level'
  if (path.startsWith('/management')) {
    const engineeringRoles = MODES.find(m => m.id === 'engineering').roles
    return engineeringRoles.some(r => roles.includes(r)) ? 'engineering' : 'c_level'
  }
  return 'engineering'
}

function modesFor(roles, user) {
  return MODES.filter(m => puedeEntrar(m, user, roles))
}

export default function Layout({ children }) {
  const { user, logout, refreshUser } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation(['nav', 'common'])
  const roles = user?.roles || (user?.role ? [user.role] : [])
  const isAdmin = roles.includes('admin')
  // Engineering "full participant" — has at least one engineering-domain role.
  const isEngineeringFull = isAdmin || roles.some(r => r === 'pm_po' || r === 'engineer')

  const pathMode = modeFromPath(location.pathname, roles)
  const availableModes = modesFor(roles, user)
  // On a shared route: the last workspace this user was in, if they still
  // have it, else their first one.
  const lastMode = localStorage.getItem(MODE_KEY)
  const mode = pathMode
    || (availableModes.some(m => m.id === lastMode) ? lastMode : availableModes[0]?.id || 'engineering')
  useEffect(() => {
    if (pathMode) localStorage.setItem(MODE_KEY, pathMode)
  }, [pathMode])
  const currentModeDef = MODES.find(m => m.id === mode)

  const [collapsed, setCollapsed] = useState(() =>
    localStorage.getItem('sidebar_collapsed') === '1'
  )
  const [switcherOpen, setSwitcherOpen] = useState(false)
  const switcherRef = useRef(null)

  // Leave requests waiting on this user (an area head or an admin), as a
  // badge on Personas. Once on mount, and again when Personas decides one
  // (it fires 'time-off-inbox-changed'); an error just leaves no badge.
  const [porAprobar, setPorAprobar] = useState(0)
  useEffect(() => {
    let cancelled = false
    const cargar = () => getTimeOffInbox()
      .then(rows => { if (!cancelled) setPorAprobar(rows.length) })
      .catch(() => {})
    cargar()
    window.addEventListener('time-off-inbox-changed', cargar)
    return () => { cancelled = true; window.removeEventListener('time-off-inbox-changed', cargar) }
  }, [])

  useEffect(() => {
    localStorage.setItem('sidebar_collapsed', collapsed ? '1' : '0')
  }, [collapsed])

  // The bottom block (Personas, notifications, help, API keys, settings,
  // language) can be minimized to a row of icons. Remembered in this browser.
  const [pieMin, setPieMin] = useState(() => { try { return localStorage.getItem('sidebar_pie_min') === '1' } catch { return false } })
  const alternarPie = (v) => { setPieMin(v); try { localStorage.setItem('sidebar_pie_min', v ? '1' : '0') } catch { /* private mode */ } }
  const compacto = collapsed || pieMin

  // Sidebar sections fold: a closed one hides its items (but the page you
  // are on stays in sight). Remembered in this browser, per workspace.
  const [cerradas, setCerradas] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sidebar_secciones_cerradas') || '[]') } catch { return [] }
  })
  const alternarSeccion = (clave) => setCerradas(cs => {
    const nuevas = cs.includes(clave) ? cs.filter(c => c !== clave) : [...cs, clave]
    try { localStorage.setItem('sidebar_secciones_cerradas', JSON.stringify(nuevas)) } catch { /* private mode */ }
    return nuevas
  })

  // Close switcher on outside click
  useEffect(() => {
    if (!switcherOpen) return
    const handler = (e) => {
      if (switcherRef.current && !switcherRef.current.contains(e.target)) {
        setSwitcherOpen(false)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [switcherOpen])

  // ── Build nav groups per mode ──
  let navGroups = []
  if (mode === 'engineering') {
    const planningItems = [
      { to: '/',          label: t('nav:items.dashboard'), Icon: Icons.Dashboard },
      ...(isAdmin ? [{ to: '/plan', label: t('nav:items.planWeek'), Icon: Icons.PlanWeek }] : []),
      ...(isEngineeringFull ? [{ to: '/schedule', label: t('nav:items.historic'), Icon: Icons.Schedule }] : []),
    ]
    const resourceItems = [
      { to: '/projects', label: t('nav:items.projects'), Icon: Icons.Projects },
      ...(isEngineeringFull ? [{ to: '/time-off', label: t('nav:items.timeOff'), Icon: Icons.TimeOff }] : []),
    ]
    const requestsItems = [
      { to: '/requests/purchases', label: t('nav:items.purchase'), Icon: Icons.Cart },
      { to: '/operations/planta/ot/nueva', label: t('nav:items.otSolicitud'), Icon: Icons.Requests },
    ]
    const managementItems = isAdmin ? [
      // Under the "Management" group header, so the item names what it shows
      // rather than repeating the group.
      { to: '/management',    label: t('nav:items.overview'),   Icon: Icons.Status },
      { to: '/s-curve',       label: t('nav:items.sCurve'),            Icon: Icons.SCurve },
    ] : []
    navGroups = [
      { label: t('nav:groups.planning'),  items: planningItems },
      { label: t('nav:groups.resources'), items: resourceItems },
      { label: t('nav:groups.requests'),  items: requestsItems },
      ...(managementItems.length ? [{ label: t('nav:groups.management'), items: managementItems }] : []),
    ]
  } else if (mode === 'acquisitions') {
    const canPurchasesDashboard = ['admin', 'purchaser'].some(r => roles.includes(r))
    const canPurchaseBoard = ['admin', 'purchaser', 'pm_po', 'c_level'].some(r => roles.includes(r))
    navGroups = [
      { label: t('nav:groups.acquisitions'), items: [
        ...(canPurchasesDashboard ? [{ to: '/purchases/dashboard', label: t('nav:items.dashboard'), Icon: Icons.Dashboard }] : []),
        { to: '/purchases', label: t('nav:items.purchaseRequests'), Icon: Icons.Cart, end: true },
        ...(canPurchaseBoard ? [
          { to: '/purchases/priority', label: t('nav:items.priorityQueue'), Icon: Icons.Tasks },
        ] : []),
        ...(canPurchasesDashboard ? [{ to: '/compras/bandeja', label: t('nav:items.comprasBandeja'), Icon: Icons.Tasks }] : []),
        { to: '/compras/pedidos', label: t('nav:items.comprasPedidos'), Icon: Icons.Status },
        { to: '/purchases/flow', label: t('nav:items.purchaseFlow'), Icon: Icons.Help },
      ] },
    ]
  } else if (mode === 'crm') {
    const canCRMDashboard = ['admin', 'commercial'].some(r => roles.includes(r))
    navGroups = [
      { label: t('nav:groups.crm'), items: [
        ...(canCRMDashboard ? [{ to: '/crm/dashboard', label: t('nav:items.dashboard'), Icon: Icons.Dashboard }] : []),
        { to: '/crm',       label: t('nav:items.pipeline'), Icon: Icons.CRM, end: true },
        { to: '/crm/tasks', label: t('nav:items.tasks'),    Icon: Icons.Tasks },
      ] },
      { label: t('nav:groups.requests'), items: [
        { to: '/requests/purchases', label: t('nav:items.purchaseRequest'), Icon: Icons.Cart },
      ] },
    ]
  } else if (mode === 'comercial') {
    // Comercial's menu by its own functions (comercialLogica.navComercial):
    // CRM (organizations, contacts) and its administration (types, labels, permissions).
    navGroups = navComercial(user).map(g => ({
      label: t(`nav:groups.${g.grupo}`),
      items: g.items.map(i => ({ to: i.to, label: t(`nav:items.${i.clave}`), Icon: Icons[i.icono] })),
    }))
  } else if (mode === 'operations') {
    navGroups = [
      // Órdenes de trabajo: not for a mantenimiento-only user.
      ...(entraAOt(user) ? [{ label: t('nav:groups.planta'), items: [
        { to: '/operations/planta/ot',       label: t('nav:items.otTablero'), Icon: Icons.Board, end: true },
        { to: '/operations/planta/ot/nueva', label: t('nav:items.otNueva'), Icon: Icons.Plus },
        { to: '/operations/planta/admision', label: t('nav:items.otAdmision'), Icon: Icons.Requests },
        { to: '/operations/planta/cola-sap', label: t('nav:items.otColaSap'),  Icon: Icons.Warehouse },
        { to: '/operations/planta/trabajo',  label: t('nav:items.otTrabajo'),  Icon: Icons.Team },
        { to: '/operations/planta/indicadores', label: t('nav:items.otIndicadores'), Icon: Icons.SCurve },
      ] }] : []),
      { label: t('nav:groups.maintenance'), items: [
        { to: '/operations/unidades', label: t('nav:items.unidades'), Icon: Icons.Wrench },
        { to: '/operations/partes',   label: t('nav:items.partes'),   Icon: Icons.Requests },
        { to: '/operations/asignaciones', label: t('nav:items.asignaciones'), Icon: Icons.Tasks },
      ] },
      { label: t('nav:groups.requests'), items: [
        { to: '/requests/purchases', label: t('nav:items.purchaseRequest'), Icon: Icons.Cart },
      ] },
      // Operaciones' own administration, apart from the daily work: work groups,
      // permissions by function and the bulk loads from monday (one page, tabs).
      { label: t('nav:groups.adminOperaciones'), items: [
        ...(entraAOt(user) ? [
          { to: '/operations/planta/grupos',   label: t('nav:items.otGrupos'),   Icon: Icons.Team },
          { to: '/operations/planta/permisos', label: t('nav:items.otPermisos'), Icon: Icons.Key },
        ] : []),
        { to: '/operations/carga-masiva', label: t('nav:items.cargaMasiva'), Icon: Icons.Requests },
      ] },
    ]
  } else if (mode === 'c_level') {
    navGroups = [
      { label: t('nav:groups.executive'), items: [
        { to: '/c-level',    label: t('nav:items.overview'),          Icon: Icons.SCurve, end: true },
        { to: '/capacity',   label: t('nav:items.capacity'),   Icon: Icons.Team },
        { to: '/management', label: t('nav:items.management'), Icon: Icons.Status },
        // c_level EXACTLY -- mirrors the backend's require_exactly("c_level")
        // gate (routers/scenarios.py). An admin who switches into this mode
        // but isn't ALSO c_level simply never sees this link, same as they
        // never see the money on Tarifas.
        ...(roles.includes('c_level')
          ? [{ to: '/scenarios', label: t('nav:items.scenarios'), Icon: Icons.Status }]
          : []),
      ] },
      { label: t('nav:groups.acquisitions'), items: [
        // c_level's own mode (['admin','c_level']) doesn't include the acquisitions
        // mode's role set — this is otherwise the only way a plain c_level user
        // (not also admin/pm_po/purchaser) reaches the priority queue they set.
        { to: '/purchases/priority', label: t('nav:items.priorityQueue'), Icon: Icons.Cart },
      ] },
      { label: t('nav:groups.requests'), items: [
        { to: '/requests/purchases', label: t('nav:items.purchaseRequest'), Icon: Icons.Cart },
      ] },
    ]
  } else if (mode === 'admin') {
    const contratos = { to: '/admin/contratos', label: t('nav:items.adminContratos'), Icon: Icons.Requests }
    const esRrhh = roles.includes('rrhh')
    navGroups = !(isAdmin || esRrhh) ? [{ label: t('nav:groups.admin'), items: [contratos] }] : [
      { label: t('nav:groups.admin'), items: [
        { to: '/admin/personas',   label: t('nav:items.adminPersonas'),   Icon: Icons.Team, tambien: ['/admin/cuentas', '/admin/duplicados'] },
        { to: '/admin/areas',      label: t('nav:items.adminAreasEsp'),   Icon: Icons.Operations, tambien: ['/admin/cargos'] },
        { to: '/admin/calendario', label: t('nav:items.adminCalendario'), Icon: Icons.TimeOff },
        contratos,
        ...(isAdmin ? [{ to: '/admin/proyectos',  label: t('nav:items.adminProyectos'),  Icon: Icons.Projects }] : []),
      ] },
    ]
  }

  const handleLogout = () => { logout(); navigate('/login') }

  const switchMode = (m) => {
    setSwitcherOpen(false)
    if (m.id === mode) return
    // Someone who sees Mantenimiento but not the work orders lands on Unidades;
    // someone in Administración only for Contratos (rrhh, c_level), on Contratos.
    navigate(homeDe(m.id, user) || m.home)
  }
  // The workspace the app opens on after signing in (★ in the switcher; again to unset).
  const inicio = user?.espacio_inicio || null
  const fijarInicio = (m) => {
    setEspacioInicio(inicio === m.id ? null : m.id).then(() => refreshUser?.()).catch(() => {})
  }

  return (
    <div className="flex h-screen overflow-hidden bg-[#f7f7f8]">
      {/* Every table's columns resize by dragging the header's edge (AnchoColumnas). */}
      <RedimensionarTablas />

      {/* Sidebar */}
      <aside className={`relative ${collapsed ? 'w-[60px]' : 'w-[220px]'} shrink-0 bg-white border-r border-gray-100 flex flex-col transition-all duration-200`}>

        {/* Header */}
        <div className={`flex items-center border-b border-gray-100 h-[56px] shrink-0 ${collapsed ? 'justify-center px-0' : 'px-4 justify-between'}`}>
          {collapsed ? (
            <img src="/logo.png" alt="REM logo" className="w-7 h-7 rounded-md" />
          ) : (
            <>
              <div className="flex items-center gap-2.5 min-w-0">
                <img src="/logo.png" alt="REM logo" className="w-7 h-7 rounded-md shrink-0" />
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-gray-900 leading-tight tracking-tight">REM PMO</p>
                  <p className="text-[10px] text-gray-400 leading-tight">{t('nav:appSubtitle')}</p>
                </div>
              </div>
              <button onClick={() => setCollapsed(true)} title={t('nav:collapseSidebar')}
                className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md p-1 transition-colors shrink-0">
                <Icons.ChevronLeft />
              </button>
            </>
          )}
        </div>

        {/* Workspace switcher (only when expanded) */}
        {!collapsed && availableModes.length > 0 && (
          <div className="px-3 pt-3 pb-1 relative" ref={switcherRef}>
            <button
              onClick={() => availableModes.length > 1 && setSwitcherOpen(o => !o)}
              disabled={availableModes.length <= 1}
              className={`w-full flex items-center justify-between gap-2 px-2.5 py-2 rounded-lg border transition-colors ${
                availableModes.length > 1
                  ? 'border-gray-200 hover:bg-gray-50 cursor-pointer'
                  : 'border-gray-100 cursor-default'
              }`}
            >
              <span className="flex items-center gap-2 min-w-0">
                {currentModeDef?.Icon && (
                  <span className="text-gray-500 shrink-0"><currentModeDef.Icon /></span>
                )}
                <span className="text-sm font-medium text-gray-800 truncate">
                  {currentModeDef ? t(`nav:modes.${currentModeDef.id}`) : t('nav:workspace')}
                </span>
              </span>
              {availableModes.length > 1 && (
                <span className="text-gray-400 shrink-0"><Icons.ChevronDown /></span>
              )}
            </button>

            {switcherOpen && availableModes.length > 1 && (
              <div className="absolute left-3 right-3 mt-1 z-20 bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
                {availableModes.map(m => {
                  const active = m.id === mode
                  const esInicio = inicio === m.id
                  return (
                    <div key={m.id} className={`flex items-center ${active ? 'bg-gray-100' : 'hover:bg-gray-50'}`}>
                      <button
                        onClick={() => switchMode(m)}
                        className={`flex-1 min-w-0 flex items-center gap-2 px-3 py-2 text-sm text-left transition-colors ${
                          active ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
                        }`}
                      >
                        <span className="text-gray-500"><m.Icon /></span>
                        <span className="truncate">{t(`nav:modes.${m.id}`)}</span>
                      </button>
                      <button type="button" onClick={() => fijarInicio(m)}
                        title={esInicio ? t('nav:inicio.quitar') : t('nav:inicio.fijar')}
                        aria-label={esInicio ? t('nav:inicio.quitar') : t('nav:inicio.fijar')}
                        className={`px-2.5 py-2 text-sm ${esInicio ? 'text-amber-500' : 'text-gray-300 hover:text-amber-400'}`}>
                        {esInicio ? '★' : '☆'}
                      </button>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )}

        {/* Expand tab */}
        {collapsed && (
          <button onClick={() => setCollapsed(false)} title={t('nav:expandSidebar')}
            className="absolute top-3 left-full flex items-center justify-center w-[18px] h-8 bg-white border border-l-0 border-gray-200 rounded-r-lg shadow-sm text-gray-400 hover:text-gray-700 hover:bg-gray-50 transition-colors z-10">
            <Icons.ChevronRight />
          </button>
        )}

        {/* Nav — min-h-0 lets flex-1 actually shrink so footer stays visible */}
        <nav className="flex-1 py-3 overflow-y-auto min-h-0">
          {navGroups.map((group, gi) => {
            const clave = `${mode}:${group.label}`
            const cerrada = !collapsed && cerradas.includes(clave)
            const enPath = (to, it) => (it.end ?? to === '/') ? location.pathname === to
              : location.pathname === to || location.pathname.startsWith(`${to}/`)
            const enRuta = (it) => [it.to, ...(it.tambien || [])].some(to => enPath(to, it))
            const visibles = cerrada ? group.items.filter(enRuta) : group.items
            return (
            <div key={gi} className={collapsed ? 'mb-1' : cerrada ? 'mb-1' : 'mb-4'}>
              {!collapsed && (
                <button type="button" onClick={() => alternarSeccion(clave)} aria-expanded={!cerrada}
                  className="group w-full flex items-center justify-between px-4 py-1 mb-0.5 text-[10px] font-semibold text-gray-400 uppercase tracking-widest hover:text-gray-600">
                  <span>{group.label}</span>
                  <span className={`transition-transform ${cerrada ? '-rotate-90' : ''} opacity-60 group-hover:opacity-100`}><Icons.ChevronDown /></span>
                </button>
              )}
              <div className="space-y-0.5 px-2">
                {visibles.map(({ to, label, Icon, end, tambien }) => (
                  <NavLink key={to} to={to} end={end ?? to === '/'} title={collapsed ? label : undefined}
                    className={({ isActive }) =>
                      `flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-colors ${collapsed ? 'justify-center' : ''} ${
                        (isActive || (tambien || []).some(p => location.pathname === p)) ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'
                      }`
                    }>
                    <span className="shrink-0"><Icon /></span>
                    {!collapsed && <span>{label}</span>}
                  </NavLink>
                ))}
              </div>
            </div>
            )
          })}
        </nav>

        {/* Personas + Help + Settings — Personas and Help for everyone, Settings admin-only.
            It can be minimized to a row of icons (remembered in this browser). */}
        <div className={`border-t border-gray-100 shrink-0 ${collapsed ? 'px-0 py-2 flex flex-col items-center gap-0.5'
          : pieMin ? 'px-1.5 py-1.5 flex flex-wrap items-center gap-0.5' : 'px-2 pt-1 pb-2 space-y-0.5'}`}>
          {!collapsed && !pieMin && (
            <button type="button" onClick={() => alternarPie(true)} aria-expanded="true" title={t('nav:minimizar')}
              className="group w-full flex items-center justify-between px-2 py-1 text-[10px] font-semibold text-gray-400 uppercase tracking-widest hover:text-gray-600">
              <span>{t('nav:mas')}</span>
              <span className="opacity-60 group-hover:opacity-100"><Icons.ChevronDown /></span>
            </button>
          )}
          {/* The company directory and leave requests: for everyone, in every workspace. */}
          <NavLink
            to="/personas"
            title={compacto ? t('nav:personas') : (porAprobar > 0 ? t('nav:personasPendientes', { count: porAprobar }) : undefined)}
            className={({ isActive }) =>
              `relative flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-colors ${compacto ? 'justify-center' : ''} ${
                isActive ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'
              }`
            }
          >
            <span className="shrink-0"><Icons.Team /></span>
            {!compacto && <span className="flex-1">{t('nav:personas')}</span>}
            {porAprobar > 0 && (
              compacto
                ? <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-red-500" />
                : <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-semibold flex items-center justify-center">
                    {porAprobar > 99 ? '99+' : porAprobar}
                  </span>
            )}
          </NavLink>
          <a
            href="/onboarding/index.html"
            target="_blank"
            rel="noopener noreferrer"
            title={compacto ? t('nav:help') : undefined}
            className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-colors text-gray-500 hover:bg-gray-50 hover:text-gray-800 ${compacto ? 'justify-center' : ''}`}
          >
            <span className="shrink-0"><Icons.Help /></span>
            {!compacto && <span>{t('nav:help')}</span>}
          </a>

          <NavLink
            to="/api-keys"
            title={compacto ? t('nav:apiKeys') : undefined}
            className={({ isActive }) =>
              `flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-colors ${compacto ? 'justify-center' : ''} ${
                isActive ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'
              }`
            }
          >
            <span className="shrink-0"><Icons.Key /></span>
            {!compacto && <span>{t('nav:apiKeys')}</span>}
          </NavLink>

          {isAdmin && (
            <NavLink
              to="/settings"
              title={compacto ? t('nav:settings') : undefined}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-colors ${compacto ? 'justify-center' : ''} ${
                  isActive ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'
                }`
              }
            >
              <span className="shrink-0"><Icons.Settings /></span>
              {!compacto && <span>{t('nav:settings')}</span>}
            </NavLink>
          )}
          <LanguageToggle collapsed={compacto} />
          {!collapsed && pieMin && (
            <button type="button" onClick={() => alternarPie(false)} aria-expanded="false" title={t('nav:expandir')}
              className="ml-auto flex items-center justify-center w-7 h-7 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700">
              <span className="rotate-180"><Icons.ChevronDown /></span>
            </button>
          )}
        </div>

        {/* User footer */}
        <div className={`border-t border-gray-100 shrink-0 ${collapsed ? 'px-0 py-3 flex flex-col items-center gap-2' : 'px-3 py-3'}`}>
          {collapsed ? (
            <>
            <NotificationBell variante="icono" />
            <button onClick={handleLogout} title={`${user?.display_name} — ${t('nav:signOut')}`}
              className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center hover:bg-gray-700 transition-colors">
              <span className="text-xs font-semibold text-white">{initials(user?.display_name || '')}</span>
            </button>
            </>
          ) : (
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center shrink-0">
                <span className="text-xs font-semibold text-white">{initials(user?.display_name || '')}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-gray-900 truncate leading-tight">{user?.display_name}</p>
                <p className="text-[10px] text-gray-400 leading-tight truncate">{roles.map(r => t(`common:roles.${r}`, r)).join(' · ')}</p>
              </div>
              <NotificationBell variante="icono" />
              <button onClick={handleLogout} title={t('nav:signOut')}
                className="shrink-0 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-md p-1.5 transition-colors">
                <Icons.Logout />
              </button>
            </div>
          )}
        </div>
      </aside>

      {/* Main — scrolls independently */}
      <main className="flex-1 overflow-auto">
        {children}
      </main>

      <AlertModal />
    </div>
  )
}
